import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  showSpinner = false;

  constructor(private readonly spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.spinnerState.subscribe((state: boolean) => {
      this.showSpinner = state;
    });
  }
}